<template lang="pug">
section
    BaseHeader(
        titulo='Registrar Persona'
        icon='mdi mdi-account-plus'
        :exibeBotao='false'
        :voltarPara='true'
    )

    div.view-container.margen-bottom-pages.body
        CadastroLote(
            @buscarResultadoLote='buscarResultadoLote'
            @dadosLoteAtualizado='onDadosLoteAtualizado'
        )
        CadastroManual(@adicionarPessoaManualmente='adicionarPessoa' :pessoasJaAdicionadas='pessoas')

        div
            TabelaCadastroPessoas(
                :pessoas='pessoas'
                :removendo='removendoPessoas'
                @pessoasSelecionadas='selecionarPessoas'
            )

            div.pagination
                b {{ pessoas.length }} persona{{ pessoas.length !== 1 ? 's' : '' }}

                el-pagination(
                    small
                    background
                    layout='prev, pager, next'
                    :page-size='paginacao.tamanho'
                    :current-page.sync='paginacao.pagina'
                    :total='paginacao.total'
                    @current-change='atualizarPagina'
                )

    footer.footer-acoes
        div.remover
            el-button(
                v-if='removendoPessoas'
                @click.native='removendoPessoas = false'
            ) Cancelar

            el-button(
                v-if='!removendoPessoas'
                type='danger'
                icon='el-icon-delete'
                @click.native='removendoPessoas = true'
            ) Eliminar

            el-button(
                v-else
                type='danger'
                icon='el-icon-delete'
                @click.native='removerPessoas'
            ) Confirmar la extracción

        el-button(
            v-if='podeConfirmar'
            type='primary'
            icon='el-icon-s-promotion'
            :loading='confirmando'
            @click.native='confirmarLote'
        ) Ingresar personas
</template>

<script>
import BaseHeader from '@/components/BaseHeader.vue';
import CadastroLote from './componentes/cadastro-lote/index.vue';
import CadastroManual from './componentes/cadastro-manual/index.vue';
import TabelaCadastroPessoas from './componentes/tabela-pessoas/index.vue';
import PessoaServiceArgentina from '@/services/PessoaServiceArgentina.js';

export default {
    name: 'index',
    components: {
        BaseHeader,
        CadastroLote,
        CadastroManual,
        TabelaCadastroPessoas
    },
    data() {
        return {
            pessoas: [],
            removendoPessoas: false,
            pessoasSelecionadas: [],
            loading: false,
            paginacao: {
                pagina: 0,
                ordenacao: 'data_cadastro,desc',
                tamanho: 10,
                total: 0
            }
        };
    },

    computed: {
        podeConfirmar() {
            const loteCompleto = ['CONCLUIDO', 'CONCLUIDO_COM_ERROS'].includes(this.dadosLote?.status);
            return loteCompleto || this.pessoas.length > 0;
        }
    },

    mounted() {},

    methods: {
        adicionarPessoa(pessoa) {
            this.pessoas = [...this.pessoas, pessoa];
        },

        selecionarPessoas(selecionadas) {
            this.pessoasSelecionadas = selecionadas;
        },

        async removerPessoas() {
            const selecionadas = new Set(this.pessoasSelecionadas);
            const idsDoLote = this.pessoasSelecionadas
                .filter(p => p.id != null)
                .map(p => p.id);

            if (idsDoLote.length > 0) {
                try {
                    await PessoaServiceArgentina.cancelarItensLote(idsDoLote);
                } catch {
                    this.$notify.error('Error al eliminar los registros del lote.');
                    return;
                }
            }

            this.pessoas = this.pessoas.filter(p => !selecionadas.has(p));
            this.pessoasSelecionadas = [];
            this.removendoPessoas = false;
        },

        async confirmarLote() {
            this.confirmando = true;
            try {
                if (['CONCLUIDO', 'CONCLUIDO_COM_ERROS'].includes(this.dadosLote?.status)) {
                    const { data } = await PessoaServiceArgentina.confirmarLote(this.dadosLote.id);

                    if (data.cuitsDuplicados?.length > 0) {
                        this.$notify.warning({
                            title: 'CUIT ya registrado',
                            message: `Los siguientes CUIT no fueron registrados porque ya existen: ${data.cuitsDuplicados.join(', ')}`,
                            duration: 0
                        });
                    }

                    if (data.totalCadastrados === 0) return;
                } else {
                    const payload = this.pessoas.map(p => ({
                        nomeRazaoSocial: p.nomeRazaoSocial,
                        documento: p.cuit,
                        email: p.email || null,
                        telefone: p.telefone || null,
                        localidadeNivelUm: p.provincia?.id,
                        localidadeNivelDois: p.departamento?.id,
                        localidadeNivelTres: p.localidade?.id,
                        idCliente: p.idCliente || null
                    }));
                    const { data } = await PessoaServiceArgentina.cadastrarPessoas(payload);

                    if (data.cuitsDuplicados?.length > 0) {
                        this.$notify.warning({
                            title: 'CUIT ya registrado',
                            message: `Los siguientes CUIT no fueron registrados porque ya existen: ${data.cuitsDuplicados.join(', ')}`,
                            duration: 0
                        });
                    }

                    if (data.totalCadastrados === 0) return;

                    this.$notify.success({ message: `${data.totalCadastrados} persona${data.totalCadastrados !== 1 ? 's' : ''} registrada${data.totalCadastrados !== 1 ? 's' : ''} con éxito.` });
                    this.$router.push('/pessoa');
                    return;
                }
                this.$notify.success({ message: `${this.pessoas.length} personas registradas con éxito.` });
                this.$router.push('/pessoa');
            } catch (error) {
                this.$notify.error({
                    title: 'Error',
                    message: 'Error al registrar personas'
                });
            } finally {
                this.loading = true;
            }
        },

        async buscarResultadoLote() {
            this.loading = true;
            try {
                const {data} = await PessoaServiceArgentina.buscarResultadoLote(this.paginacao);

                this.pessoas = [
                    ...this.pessoas,
                    ...data.itens.map(pessoa => this.listagemPessoasFactory(pessoa))
                ];

                this.paginacao.total = data.paginacao.total;
            } catch (error) {
                this.$notify.error('Error al recuperar los resultados del lote.');
            }
            this.loading = false;
        },

        atualizarPagina(pagina) {
            this.paginacao.pagina = pagina;
            this.buscarResultadoLote();
        },

        listagemPessoasFactory(pessoa) {
            const {
                id,
                nomeRazaoSocial,
                documento: cuit,
                email,
                telefone,
                localidadeNivelUm: provincia,
                localidadeNivelDois: departamento,
                localidadeNivelTres: localidade,
                idCliente
            } = pessoa;

            return {
                id,
                pais: 'Argentina',
                nomeRazaoSocial,
                cuit,
                telefone,
                email,
                provincia,
                departamento,
                localidade,
                idCliente
            };
        },

        payloadPessoaFactory(pessoa) {
            const {
                nomeRazaoSocial,
                cuit: documento,
                email,
                telefone,
                provincia,
                departamento,
                localidade,
                idCliente
            } = pessoa;

            const cuitSemFormatacao = documento.replace(/\D/g, '');

            return {
                nomeRazaoSocial,
                documento: cuitSemFormatacao,
                email,
                telefone,
                localidadeNivelUm: provincia.id,
                localidadeNivelDois: departamento.id,
                localidadeNivelTres: localidade.id,
                idCliente
            };
        }
    }
};
</script>

<style lang="scss" scoped>
.body {
    margin-top: 16px;
    display: flex;
    flex-direction: column;
    gap: 16px;
}

.footer-acoes {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 16px;
    margin-top: 8px;
}

.pagination {
    display: flex;
    align-items: center;
    justify-content: space-between;
    align-items: center;
    background: var(--white);
    padding: 14px 11px;
    border-bottom-left-radius: 11px;
    border-bottom-right-radius: 11px;

    b {
        color: var(--primary);
        font-size: 12px;
    }
}
</style>
